module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "header",
    attrs: {
      "href": '//www.youtube.com/channel/' + _vm.video.channel_id,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.video.channel_title))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "extra"
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "hrxef": 'https://youtu.be/' + _vm.video.video_id,
      "target": "_blank"
    },
    on: {
      "click": _vm.show
    }
  }, [_vm._v(_vm._s(_vm.video.title))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('i', {
    staticClass: "material-icons mdl-list__item-avatar"
  }, [_vm._v("person")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meta"
  }, [_c('span', [_vm._v("Description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description"
  }, [_c('p')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27a4fafc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/videos/VideoListItem.vue
// module id = 50
// module chunks = 1 2